import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

export default function UpdateAvailableModal() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistration().then(reg => {
        if (!reg) return;

        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;

          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              setWaitingWorker(newWorker);
              setShow(true);
            }
          });
        });

        // Verificar se já existe um worker esperando
        if (reg.waiting && navigator.serviceWorker.controller) {
          setWaitingWorker(reg.waiting);
          setShow(true);
        }
      });
    }
  }, []);

  const reloadApp = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ action: "skipWaiting" });
    }

    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ action: "skipWaiting" });
    }

    window.location.reload();
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogTitle>Nova versão disponível</DialogTitle>
      <DialogContent>
        <Typography>
          Uma nova atualização está pronta. Deseja atualizar agora?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Depois
        </Button>
        <Button variant="contained" onClick={reloadApp} color="primary">
          Atualizar agora
        </Button>
      </DialogActions>
    </Dialog>
  );
}
